import { CompraVendaResumoResponse, CompraVendaStatus, OperacaoTipo } from 'common/genericTypes';

export const isRetornoDeCompromissada = (tipo?: string): boolean =>
  tipo === OperacaoTipo.CompraVendaCompromissadaRetorno;

export const isPrecoUnitarioDeLiquidacaoInvalido = (precoUnitario?: number | null): boolean =>
  typeof precoUnitario !== 'number' || Number.isNaN(precoUnitario) || precoUnitario <= 0;

export const resolverPrecoUnitarioDaLiquidacao = (tipo?: string, precoUnitarioInformado?: number): number | undefined =>
  isRetornoDeCompromissada(tipo) ? precoUnitarioInformado : undefined;

export const contraparteNaoPodeLiquidarRetorno = (
  tipo?: string,
  isOriginador?: boolean,
  isUsuarioOperacoes?: boolean
): boolean => isRetornoDeCompromissada(tipo) && isOriginador !== true && isUsuarioOperacoes !== true;

export interface ParticipanteLogado {
  id?: string;
  razaoSocial?: string;
}

export const isOriginadorDaOperacao = (
  item: Pick<CompraVendaResumoResponse, 'participanteOrigemId' | 'custodianteOrigem'>,
  participanteLogado: ParticipanteLogado
): boolean =>
  item.participanteOrigemId
    ? item.participanteOrigemId === participanteLogado.id
    : item.custodianteOrigem === participanteLogado.razaoSocial;

export const podeConfirmarLiquidacaoDaCompromissada = (
  item: CompraVendaResumoResponse,
  participanteLogado: ParticipanteLogado,
  isUsuarioOperacoes?: boolean
): boolean =>
  item.status === CompraVendaStatus.AguardandoLiquidacao &&
  !contraparteNaoPodeLiquidarRetorno(item.tipo, isOriginadorDaOperacao(item, participanteLogado), isUsuarioOperacoes);

export const deveExibirPrecoUnitarioCalculado = (tipo?: string): boolean => !isRetornoDeCompromissada(tipo);

export const resolverPrecoUnitarioExibidoNaLiquidacao = (
  tipo?: string,
  precoUnitarioCalculado?: number | null,
  precoUnitarioInformado?: number | null
): number => (isRetornoDeCompromissada(tipo) ? precoUnitarioInformado ?? 0 : precoUnitarioCalculado ?? 0);

export const descreverIdaOuVoltaDaCompromissada = (tipo?: string): string => {
  if (tipo === OperacaoTipo.CompraVendaCompromissada) {
    return 'IDA';
  }
  if (isRetornoDeCompromissada(tipo)) {
    return 'VOLTA';
  }
  return '-';
};
